module.exports = __webpack_public_path__ + "static/header-right-banner-a01858dfda3a9a6d300e106782dba0ec.jpg";